<template lang="pug">
.bonus-data-container(@click="expand = !expand")
  .bonus-data
    .menu-icon-bonus.relative(@click.stop="")
      img(:src="require('@/assets/menu.svg')" alt="menu" @click="showMenu")
      transition(name="opacity-bottom")
        shMenuBonus(v-if="showedMenu" @sendNotification="sendNotification" @openNotificationHistory="openNotificationHistory" :index="indexMenu")

    .bonus-number
      span.material-symbols-outlined(:class="`color-${data.brand}`") local_offer
      span.tag(:class="`bg-${data.brand}`") {{ data.bonus }}

    .bonus-order(v-if="!history && data.order")
      span.material-symbols-outlined(:class="`color-${data.brand}`") shopping_cart
      span.tag(:class="`bg-${data.brand}`") {{ data.order }}

    .bonus-phone {{ data.phone }}

    .bonus-status(v-if="!history")
      .tag(:style="styleStatus") {{ translateStatus(data.status) }}

    .bonus-type(v-if="!history") {{ translateType(data.type) }}

    .bonus-original(v-if="!history") {{ money(data.originalValue) }}

    .bonus-used(v-if="!history") {{ money(data.usedValue) }}

    .bonus-remaining(v-if="!history") {{ money(data.remainingValue) }}

    .bonus-depleted(v-if="!history")
      span.tag(:class="{ 'tag-depleted': data.used || data.status === 'declined', 'tag-has-balance': !data.used && data.status !== 'declined' }") {{ depletedLabel }}

    .bonus-date(v-if="!history") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

    .bonus-pack-icon(v-if="showPackIcon" :class="{ 'is-pack-pending': !data.packReceived }" @click.stop="")
      shActionButton(
        :action="togglePackReceived"
        :params="[data.bonus]"
        icon="inventory_2"
        :text="data.packReceived ? 'Deshacer recibido' : 'Recibir paquete'"
        :textRunning="data.packReceived ? 'Deshaciendo' : 'Recibiendo'"
        :normalColor="true"
        :textConfirmation="data.packReceived ? '¿Desea deshacer el paquete recibido?' : '¿Desea recibir el paquete?'"
      )

  .bonus-actions-container(@click.stop="")
    .bonus-actions
      .buttons-actions(v-if="data.status === 'created'")
        shActionButton(:action="approve" :params="[data.bonus]" text="Aprobar" textRunning="Aprobando")
        shActionButton(:action="decline" :params="[data.bonus]" text="Rechazar" textRunning="Rechazando")

      .buttons-actions(v-if="data.status === 'approved'")
        shActionButton(:action="disapprove" :params="[data.bonus]" text="Desaprobar" textRunning="Desaprobando")
        shActionButton(:action="decline" :params="[data.bonus]" text="Rechazar" textRunning="Rechazando")

  NotificationHistoryModal(
    :show="notificationHistoryModal.show"
    title="Historial de notificaciones"
    codeLabel="Bono"
    :code="notificationHistoryModal.bonus"
    :entries="notificationHistoryEntries"
    @close="closeNotificationHistory"
  )

  transition(name="slide-fade")
    shForm.list-bonus(v-if="expand && !history" :dataOriginal="data" :fillData="true")
</template>

<script>
import shForm from './Form'
import shActionButton from '@/components/elements/ActionButton'
import shMenuBonus from './MenuBonus'
import NotificationHistoryModal from '@/components/elements/NotificationHistoryModal.vue'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import gqlBonus from '@/graphql/bonus'
import gql from '@my/graphql'
import modals from '@my/store/modals'

export default {
  name: 'Bonus',

  mixins: [mFilters, mForm],

  components: { shForm, shActionButton, shMenuBonus, NotificationHistoryModal },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false,
      indexMenu: -1,
      notificationHistoryModal: {
        show: false,
        bonus: ''
      }
    }
  },

  beforeDestroy () {
    this.expand = false
  },

  methods: {
    async approve (bonus) {
      const mutation = gqlBonus.APPROVE

      if (!bonus) return

      const response = await gql.mutate(mutation, { bonus })

      if (response) modals.showMessage({ message: `Se aprobó el bono ${bonus} correctamente` })
    },

    async disapprove (bonus) {
      const mutation = gqlBonus.DISAPPROVE

      if (!bonus) return

      const response = await gql.mutate(mutation, { bonus })

      if (response) modals.showMessage({ message: `Se desaprobó el bono ${bonus} correctamente` })
    },

    async decline (bonus) {
      const mutation = gqlBonus.DECLINE

      if (!bonus) return

      const response = await gql.mutate(mutation, { bonus })

      if (response) modals.showMessage({ message: `Se rechazó el bono ${bonus} correctamente` })
    },

    async sendNotification () {
      const bonus = this.data && this.data.bonus
      if (!bonus) return
      const response = await gql.mutate(gqlBonus.SEND_NOTIFICATION, { bonus })
      if (response) modals.showMessage({ message: `Se envió la notificación del bono ${bonus}` })
    },

    openNotificationHistory () {
      this.notificationHistoryModal.bonus = this.data && this.data.bonus
      this.notificationHistoryModal.show = true
    },

    closeNotificationHistory () {
      this.notificationHistoryModal.show = false
    },

    async showMenu () {
      if (this.showedMenu) {
        this.hideMenu()
        return
      }

      if (this.indexMenu !== -1) {
        this.$store.commit('showMenu', this.indexMenu)
        return
      }

      this.indexMenu = await this.$store.dispatch('setMenu')
    },

    hideMenu () {
      this.$store.commit('hideMenu', this.indexMenu)
    },

    async receivePackage (bonus) {
      const mutation = gqlBonus.RECEIVE_PACKAGE
      if (!bonus) return
      const response = await gql.mutate(mutation, { bonus })
      if (response) modals.showMessage({ message: `Paquete recibido para el bono ${bonus}` })
    },

    async unreceivePackage (bonus) {
      const mutation = gqlBonus.UNRECEIVE_PACKAGE
      if (!bonus) return
      const response = await gql.mutate(mutation, { bonus })
      if (response) modals.showMessage({ message: `Se deshizo el recibido del paquete para el bono ${bonus}` })
    },

    async togglePackReceived (bonus) {
      if (this.data.packReceived) return this.unreceivePackage(bonus)
      return this.receivePackage(bonus)
    },

    translateStatus (status) {
      const map = {
        created: 'Creado',
        approved: 'Aprobado',
        declined: 'Declinado'
      }
      return map[status] || status
    },

    translateType (type) {
      const typeMap = {
        'refund': 'Reembolso',
        'change': 'Cambio',
        'manual': 'Manual'
      }
      return typeMap[type] || type
    }
  },

  computed: {
    showPackIcon () {
      return !this.history && this.data.type === 'refund' && this.data.status !== 'declined'
    },

    showedMenu () {
      return this.$store.state.interface.menus[this.indexMenu]
    },

    notificationHistoryEntries () {
      return (this.data && this.data.notifications && this.data.notifications.history) || []
    },

    depletedLabel () {
      if (this.data.status === 'declined') return 'No Disponible'
      return this.data.used ? 'Usado' : 'Disponible'
    },

    styleStatus () {
      const colors = {
        created: { background: '#e9e9e7', color: '#616161' },
        approved: { background: '#A5AA72', color: '#ffffff' },
        declined: { background: '#AA7572', color: '#ffffff' }
      }
      const c = colors[this.data.status]
      if (!c) return ''
      return `background: ${c.background}; color: ${c.color}`
    }
  }
}
</script>

<style lang="stylus">
.bonus-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.bonus-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis calc(100% - 3rem)
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.bonus-actions-container
  display flex
  align-items center
  gap 1.5rem
  padding 0 1rem

.bonus-actions
  display flex
  align-items center
  gap 1em

.menu-icon-bonus img
  height 1em
  cursor pointer
  position relative
  top .1em

.bonus-number, .bonus-order
  display flex
  align-items center
  gap .5em

.bonus-number .mdi
  font-size 1.4em

.list-bonus
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .bonus-data
    flex-basis calc(100% - 13.5rem - 5rem)
    column-gap 0
    row-gap 1em

  .bonus-number
    width 8em
  .bonus-order
    width 8em
  .bonus-phone
    width 8em
  .bonus-status
    width 8em
  .bonus-type
    width 7em
  .bonus-original
    width 8em
  .bonus-used
    width 8em
  .bonus-remaining
    width 8em
  .bonus-depleted
    width 9em
    .tag-depleted
      background #777
      color #fff
    .tag-has-balance
      background rgba(92, 184, 92, .22)
      color #2d5d2d
  .bonus-date
    width 10em
  .bonus-reason
    width 10em
  .bonus-actions
    width 13.5em

  .bonus-pack-icon
    margin-left auto
    opacity 1

  .bonus-pack-icon.is-pack-pending
    opacity 0.4

  .bonus-actions-container
    padding 0
</style>



// WEBPACK FOOTER //
// src/components/pages/bonus/Bonus.vue